import * as yup from 'yup';

const ICD_10_CODE_PATTERN = /^[A-Z][0-9][0-9AB](\.[A-Z0-9]{1,4})?$/;
const ICD_10_CODE_MESSAGE = 'Must be a valid ICD-10 code format (e.g., M54.50)';

export interface IcdCodeFormValues {
  indication: string;
  universalCode: string;
  rightCode: string;
  leftCode: string;
  startDate: Date | null;
  endDate: Date | null;
}

export const DEFAULT_ICD_CODE_FORM_VALUES: IcdCodeFormValues = {
  indication: '',
  universalCode: '',
  rightCode: '',
  leftCode: '',
  startDate: null,
  endDate: null,
};

export const IcdCodeValidationSchema = yup.object({
  indication: yup.string().trim().required('Indication is required'),
  universalCode: yup
    .string()
    .trim()
    .required('Universal code is required')
    .matches(ICD_10_CODE_PATTERN, ICD_10_CODE_MESSAGE),
  rightCode: yup
    .string()
    .defined()
    .test('rightCode', ICD_10_CODE_MESSAGE, value => {
      if (!value) return true;
      return ICD_10_CODE_PATTERN.test(value);
    }),
  leftCode: yup
    .string()
    .defined()
    .test('leftCode', ICD_10_CODE_MESSAGE, value => {
      if (!value) return true;
      return ICD_10_CODE_PATTERN.test(value);
    }),
  startDate: yup
    .date()
    .typeError('Invalid date')
    .nullable()
    .required('Start date is required'),
  endDate: yup
    .date()
    .typeError('Invalid date')
    .nullable()
    .required('End date is required')
    .test('endDate', 'End date must be after start date', function (value) {
      const { startDate } = this.parent;

      if (!value || !startDate) {
        return true;
      }

      const endTime = new Date(value).getTime();
      const startTime = new Date(startDate).getTime();

      if (isNaN(endTime) || isNaN(startTime)) {
        return true;
      }

      return endTime > startTime;
    }),
}) as yup.ObjectSchema<IcdCodeFormValues>;
